<template>
  <footer id="contact" class="bg-safari-dark text-white">
    <div class="container mx-auto px-4 md:px-6 py-12 md:py-16">
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12">
        <!-- Logo & Description -->
        <div>
          <img src="/icons/SAFARISTRIVESbgremoved.png" alt="Safari Strives" loading="lazy" class="h-20 mb-4">
          <p class="text-white/80 text-sm">Building economic independence through a self-funding ecosystem.</p>
        </div>

        <!-- Quick Links -->
        <div>
          <h3 class="font-bold text-lg mb-4">Quick Links</h3>
          <ul class="space-y-2">
            <li><a @click="handleQuickLink('home')" class="text-white/80 hover:text-secondary cursor-pointer text-sm">Home</a></li>
            <li><a @click="handleQuickLink('about')" class="text-white/80 hover:text-secondary cursor-pointer text-sm">About</a></li>
            <li><a @click="handleQuickLink('team')" class="text-white/80 hover:text-secondary cursor-pointer text-sm">Teams</a></li>
            <li><a @click="handleQuickLink('contact')" class="text-white/80 hover:text-secondary cursor-pointer text-sm">Contact</a></li>
          </ul>
        </div>

        <!-- Contact Info -->
        <div>
          <h3 class="font-bold text-lg mb-4">Contact</h3>
          <ul class="space-y-2 text-sm">
            <li class="text-white/80">US: +1 (331)-814-9549</li>
            <li class="text-white/80">RW: (+250) 785191825</li>
            <li><a href="mailto:contact@safaristrives.org" class="text-white/80 hover:text-secondary">contact@safaristrives.org</a></li>
            <li class="text-white/80">4922 134th St, Crestwood, IL</li>
          </ul>
        </div>

        <!-- Social Media -->
        <div>
          <h3 class="font-bold text-lg mb-4">Follow Us</h3>
          <div class="flex gap-4">
            <a href="https://www.linkedin.com/company/safari-strives/posts/?feedView=all" target="_blank" rel="noopener noreferrer" class="w-10 h-10 bg-white/10 hover:bg-secondary rounded-full flex items-center justify-center transition-colors">
              <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
              </svg>
            </a>
            <a href="https://www.youtube.com/@SafariStrives" target="_blank" rel="noopener noreferrer" class="w-10 h-10 bg-white/10 hover:bg-secondary rounded-full flex items-center justify-center transition-colors">
              <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z"/>
              </svg>
            </a>
            <a href="https://www.instagram.com/safaristrives" target="_blank" rel="noopener noreferrer" class="w-10 h-10 bg-white/10 hover:bg-secondary rounded-full flex items-center justify-center transition-colors">
              <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
              </svg>
            </a>
          </div>
        </div>
      </div>

      <!-- Bottom Bar -->
      <div class="border-t border-white/20 mt-8 pt-8 text-center">
        <p class="text-white/60 text-sm">&copy; {{ new Date().getFullYear() }} Safari Strives. All rights reserved.</p>
      </div>
    </div>
  </footer>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'

@Options({
  methods: {
    scrollToSection(id: string) {
      const element = document.getElementById(id)
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' })
      }
    },
    handleQuickLink(id: string) {
      if (id === 'team') {
        // Navigate to team route
        this.$router.push('/team')
      } else if (id === 'about') {
        // Navigate to about route
        this.$router.push('/about')
      } else if (id === 'contact') {
        // Navigate to contact route
        this.$router.push('/contact')
      } else {
        // For 'home', navigate to home first if not already there, then scroll
        if (this.$route.path !== '/') {
          this.$router.push('/').then(() => {
            setTimeout(() => this.scrollToSection(id), 100)
          })
        } else {
          this.scrollToSection(id)
        }
      }
    }
  }
})
export default class Footer extends Vue {}
</script>
